import { createValidationSchema, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const getTenant = {
    name: "getTenant",
    description: "Returns a single tenant by id",
    type: "query",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        id: uuidField({
            required: true,
            message: "Debe ingresar un ID válido",
        }),
    }),
    useCase: async ({ db }, { id }) => {
        const tenant = await db.findOne(TenantEntity, { where: { id } });
        if (!tenant)
            return new TenantNotFoundError();
        return tenant;
    },
};
